import {
  ModalFooter as CModalFooter,
  ModalFooterProps as CModalFooterProps,
  Divider,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

const propTypes = {
  spaceBetween: PropTypes.bool,
};

const defaultProps = {
  spaceBetween: false,
};

interface ModalFooterProps extends CModalFooterProps {
  showDivider?: boolean;
  spaceBetween: boolean;
}

const ModalFooter = ({
  showDivider = true,
  spaceBetween,
  ...props
}: ModalFooterProps) => {
  return (
    <>
      {showDivider && <Divider marginX={3} marginY={0} width="auto" />}
      <CModalFooter
        paddingY={5}
        paddingX={8}
        justifyContent={spaceBetween ? 'space-between' : 'flex-end'}
        alignItems="center"
        flex="1 0"
        {...props}
      />
    </>
  );
};

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

export default ModalFooter;
